import { FdrImage } from '@hotelplan/supergraph-api';

export enum FdrStyleSettingsDynamicComponents {
  FONT_COLOR = 'fgColor',
  BACKGROUND_COLOR = 'bgColor',
}

export const getFdrStyle = <T>(
  component: T,
  styleName: FdrStyleSettingsDynamicComponents
): string | null => {
  if (
    component[styleName] !== undefined &&
    (styleName === FdrStyleSettingsDynamicComponents.FONT_COLOR ||
      styleName === FdrStyleSettingsDynamicComponents.BACKGROUND_COLOR)
  ) {
    return component[styleName];
  }

  return null;
};

export const getFdrBackgroundImage = <T>(
  component: T
): Omit<FdrImage, 'id'> | null => {
  if (component['bgImage'] !== undefined) {
    return component['bgImage'];
  }

  return null;
};

export const getFdrBottomPadding = (bottomPadding: string) =>
  bottomPadding === 'NONE'
    ? 'none-padding-bottom'
    : bottomPadding === 'SMALL'
    ? 'small-padding-bottom'
    : 'large-padding-bottom';

export const getFdrTopPadding = (topPadding: string) =>
  topPadding === 'NONE'
    ? 'none-padding-top'
    : topPadding === 'SMALL'
    ? 'small-padding-top'
    : 'large-padding-top';
